// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__L7ntr","modal":"Modal_modal__ZDVCz","slide-down":"Modal_slide-down__bHlZ-"};